export default __webpack_public_path__ + "static/media/avatar_girl.1421f1fa.png";